module.exports = __webpack_public_path__ + "static/littleWomen5-1843274e2c20f5c97a2b685df3c73e07.jpg";